import { AnimatePresence, motion } from "motion/react"
import { createRoot } from "react-dom/client"

import styles from "./index.module.scss"

interface IProps {
    visible?: boolean
    afterClose?: () => void
}

const OriginalToast: React.FC<React.PropsWithChildren<IProps>> = (props) => {
    const { visible = false, afterClose, children } = props

    return (
        <AnimatePresence onExitComplete={afterClose}>
            {visible && (
                <motion.div
                    className={styles.toast}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{
                        duration: 0.3,
                        ease: "easeInOut",
                    }}
                >
                    <div className={styles.content}>{children}</div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

interface ToastOptions {
    duration?: number
}

function message(content: React.ReactNode, opts: ToastOptions = {}) {
    if (!content) return

    const { duration = 2000 } = opts

    const div = document.createElement("div")
    document.body.appendChild(div)
    const root = createRoot(div)

    function render({
        content,
        ...props
    }: IProps & { content?: React.ReactNode }) {
        setTimeout(() => {
            root.render(<OriginalToast {...props}>{content}</OriginalToast>)
        })
    }

    render({
        visible: true,
        content,
    })

    setTimeout(() => {
        render({
            visible: false,
            content,
            afterClose: () => {
                root.unmount()
                div.remove()
            },
        })
    }, duration)
}

interface ToastStaticFunctions {
    message: (content: React.ReactNode, opts?: ToastOptions) => void
}

type Toast = typeof OriginalToast & ToastStaticFunctions

const Toast = OriginalToast as Toast
Toast.message = message

export default Toast
